import React from "react";
import { useStaticQuery, graphql } from "gatsby";

export default function CategoryText({ className, Type = "p", children }) {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "tags.yml" }) {
        childContentYaml {
          categories {
            key
            value
          }
        }
      }
    }
  `);

  const display =
    data.file.childContentYaml.categories.find(
      (set) => set.key.toUpperCase() === String(children).toUpperCase()
    )?.value || children;

  return <Type className={className}>{display}</Type>;
}
